import axios from "axios";
import { authHeaderJson } from "../auth-header.service";

const getListJobPositions = () => {
    return axios.get(`/api/jobPosition/list`, { headers: authHeaderJson() } )
};

const getJobPositionById = (jobPositionId) => {
        return axios.get(`/api/jobPosition/${jobPositionId}`, { headers: authHeaderJson() } );
};

const addJobPosition = (jobPosition) => {
    return axios.post(`/api/jobPosition/add/`, jobPosition, { headers: authHeaderJson() } );
}

const addJobPositionList = (JobPositions) => {
    return axios.post(`/api/jobPosition/add/list`, JobPositions, { headers: authHeaderJson() } );
}

const saveJobPositionById = (jobPositionId, objContract) => {
    return axios.put(`/api/jobPosition/update/${jobPositionId}`, objContract, { headers: authHeaderJson() });
};

const deleteJobPosition = (jobPositionId) => {
    return axios.delete(`/api/jobPosition/delete/${jobPositionId}`, { headers: authHeaderJson() });
}

export {
    getListJobPositions,
    getJobPositionById,
    addJobPosition,
    addJobPositionList,
    saveJobPositionById,
    deleteJobPosition
}